import { SideNavToggleButton } from "../SideNav/SideNavToggleButton/SideNavToggleButton";

import "./Toolbar.css";

export function Toolbar() {
  return (
    <>
      {<header className="toolbar">
        <div className="toolbar-content">
          <SideNavToggleButton />
          <img src="static/images/CemexLogo.png" height="30px" alt="cemex-logo" id="cemex-logo" />
          <div className="vertical-bar"></div>
          <img src="static/images/LucaControllershipLogo.jpg" height="25px" alt="luca-controllership-logo" id="luca-controllership-logo" />
          <div id="beta-tag-content">
            <span id="beta-tag">Beta Version</span>
          </div>
        </div>
      </header>}
    </>
  );
} 
